export const internalCustomerAdminActionTypes = {
    STORE_TERMINATION_REASONS: "STORE_TERMINATION_REASONS",
    STORE_SKYNET_TERMINATION_REASONS: "STORE_SKYNET_TERMINATION_REASONS",
    STORE_SERVICES: "STORE_SERVICES",
    STORE_EVENT_LOGS: "STORE_EVENT_LOGS",
    STORE_EMAIL_DELIVERY_LOGS: "STORE_EMAIL_DELIVERY_LOGS",
    CLEAR: "CLEAR"
}